import type { SVGProps } from "react";
// generated from StopSign.svg — do not edit manually
// prettier-ignore
export default function StopSign(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 17 12 H 7 M 22 12 C 22 17.5228 17.5228 22 12 22 C 6.4772 22 2 17.5228 2 12 C 2 6.4772 6.4772 2 12 2 C 17.5228 2 22 6.4772 22 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
